export default __webpack_public_path__ + "static/media/about2.b13ac4a1.jpg";